import React from "react";
import { IoIosContact } from "react-icons/io";
import { Link } from "react-router-dom";

const FixedContactButton = () => {
  return (
    <Link
      to="/contact"
      className="fixed bottom-24 right-8 bg-[#fc3c04] hover:bg-[#345bf3] text-white p-4 rounded-full shadow-lg flex items-center justify-center z-50"
      aria-label="Contact Us"
      title="Contact Us"
    >
      <IoIosContact size={24} />
    </Link>
  );
};

export default FixedContactButton;
